module.exports = __webpack_public_path__ + "static/media/c5.99e7221e.jpg";